import React from 'react';
import { FormDialog } from '../../../../components/form-dialog';
import { MissingPartialsInfo, AUDIO_CHUNK_SIZE_SECONDS } from './dialog-support-interfaces';

interface DialogSupportPartialWarningModalProps {
  open: boolean;
  partialDetails?: MissingPartialsInfo;
  onProceed: () => void;
}

function formatMissingTime(missingPartialsInfo: MissingPartialsInfo): string {
  const missingSeconds = missingPartialsInfo.missingPartialsCount * AUDIO_CHUNK_SIZE_SECONDS;
  const totalSeconds = missingPartialsInfo.totalPartialsCount * AUDIO_CHUNK_SIZE_SECONDS;

  const missingMinutes = Math.max(Math.round(missingSeconds / 60), 1);
  const totalMinutes = Math.round(totalSeconds / 60);

  if (missingMinutes === 1) return `ca. 1 minut mangler ud af i alt ca. ${totalMinutes} minutter.`;
  return `ca. ${missingMinutes} minutter af samtalen mangler ud af i alt ca. ${totalMinutes} minutter.`;
}

export function DialogSupportPartialWarningModal(props: DialogSupportPartialWarningModalProps) {
  const { open, partialDetails, onProceed } = props;

  const detailsText = partialDetails ? formatMissingTime(partialDetails) : '';

  return (
    <FormDialog
      open={open}
      title="Mangelfuld transkription"
      confirmButtonText="Ok"
      onConfirmClick={onProceed}
    >
      <div>
        Dialogstøtte er blevet ramt af en teknisk fejl i forbindelse med transskription af samtalen. Dette betyder at dele af samtalen mangler.
        Vær derfor ekstra opmærksom på om det AI genererede notat er korrekt og fyldestgørende.
        <br />
        Detaljer: {detailsText}
      </div>
    </FormDialog>
  );
}
